import React from 'react';
type SectionFigureProps = {
  src: string;
  alt: string;
  caption: string;
};
export function SectionFigure({
  src,
  alt,
  caption
}: SectionFigureProps) {
  return <figure className="my-7" data-id="element-195" data-mp="1ar543hcfo5e0">
      <img src={src} alt={alt} className="aspect-[16/9] w-full rounded-sm bg-neutral-200 object-cover" loading="lazy" data-id="element-196" data-mp="wu9jcrmtkpi4" />
      <figcaption className="mt-2 font-sans text-xs leading-relaxed text-ink-muted" data-id="element-197" data-mp="10xeick7oy920">
        {caption}
      </figcaption>
    </figure>;
}